
import { helpers } from '../helpers.js';

var poi = {
	selectors: { },

	init: function () {
		var self = this;

		self.loadTabEvents();
		self.showMore();
		self.collseumTable();
		self.switchTabFromUrl();
		self.selectTabFromElement();
		self.hoursToCheck();
	},

	hoursToCheck: function () {
		jQuery( 'body' ).on( 'showFromToDone', function(event) {
			if( jQuery( '[data-innerblock="hours"]:first-of-type [data-showfrom][data-showto]' ).length == 2 ) {
				jQuery( '[data-innertab="hours"]' ).remove();
				jQuery( '[data-innerblock="hours"]' ).remove();
			}
		});
	},

	/* showHideHistory: function() {
		if( ! document.querySelector( '.js-viewHistory' ) ) {
			return false;
		}

		document.querySelector( '.js-viewHistory' ).addEventListener( 'click', (e) => {
			e.preventDefault();

			let item = e.target;

			if( item.classList.contains( 'active' ) ) {

				item.classList.remove( 'active' );
				return;
			}
		});
	}, */

	collseumTable: function() {
		if( document.querySelectorAll( '.colloseum-listing' ).length == 0) {
			return false;
		}

		jQuery( '.colloseum-show-all' ).on( 'click', function(){
			jQuery( '.colloseum-listing' ).addClass( 'view-all' );
		});

		helpers.pctApiCall({
			action: 'load_colloseum_listing',
			ids: jQuery( '.colloseum-listing' ).attr( 'data-ids' ),
			post_id: jQuery( '.colloseum-listing' ).attr( 'data-poi' ),
		}).then( response => {
			if( ! response.success ) {
				console.error( 'Error: ', response.data.message ); 
				return false;
			}

			jQuery( '.colloseum-listing' ).html( response.data.html );

			setTimeout( function(){

				jQuery( '[name="colloseum_lang"]' ).on( 'change', function(){
					const lang = jQuery( this ).val();
					jQuery( `.colloseum-listing__row[data-lang="${lang}"]` ).toggleClass( 'd-none' );
				});

			}, 100 );
		}).catch(error => {
			console.error( 'Error: ', error); 
		});
	},

	showMore: function() {
		if( document.querySelectorAll( '.js-showMore' ).length == 0) {
			return false;
		}

		document.querySelectorAll( '.js-showMore' ).forEach(function( button, item ){
			button.addEventListener( 'click', (e) => {
				e.preventDefault();
				let div = button.nextElementSibling;
				Array.from(div.childNodes).forEach(child => {
					div.parentNode.insertBefore(child, div);
				});

				div.parentNode.removeChild(div);

				button.remove();
			});
		});
	},

	loadTabEvents: function() {
		var self = this;
		
		document.querySelectorAll( '.js-articleTabs a' ).forEach(function( button, item ){
			button.addEventListener( 'click', (e) => {
				e.preventDefault();

				if( e.target.getAttribute( 'href' ) == '#' ) {
					return;
				}

				let anchor = e.target.getAttribute( 'href' ).replace( '#', '' );
				self.switchTab( anchor );
			});
		});
		
		document.querySelectorAll( '.article-tabs__link > a' ).forEach(function( link, item ){
			if( link.getAttribute( 'href' )[0] != '#' ) return;

			link.addEventListener( 'click', (e) => {
				e.preventDefault();

				if( e.target.getAttribute( 'href' ) == '#' ) {
					return;
				}

				let anchor = e.target.getAttribute( 'href' ).replace( '#', '' );
				self.switchTab( anchor );

				const element = document.querySelector( '.js-articleTabs' );
				element.scrollIntoView({ behavior: 'smooth', block: 'start' });
			});
		});
	},

	switchTab: function( toTab ) {
		var self = this;

		if( ! document.querySelector( `#${toTab}` ) ) {
			return false;
		}

		document.querySelector( '.js-articleTabs li.active' ).classList.remove( 'active' );
		document.querySelector( '.article-tabs__content.active' ).classList.remove( 'active' );

		document.querySelector( `.js-articleTabs li:has( a[href="#${toTab}"] )` ).classList.add( 'active' );
		document.querySelector( `#${toTab}.article-tabs__content` ).classList.add( 'active' );
	},

    selectTabFromElement: function() {
        let buttonNode = document.querySelector('.switcher[href]');

        if (! buttonNode) {
            return;
        }

        const toTab = buttonNode.getAttribute('href').replace('#', '');

        buttonNode.addEventListener('click', function(event) {
            event.preventDefault();
            const activeTab = document.querySelector('.js-articleTabs li.active');
            const activeContent = document.querySelector('.article-tabs__content.active');

            if (activeTab) {
                activeTab.classList.remove('active');
            }
            if (activeContent) {
                activeContent.classList.remove('active');
            }

            const newTab = document.querySelector(`.js-articleTabs li:has(a[href="#${toTab}"])`);
            const newContent = document.querySelector(`#${toTab}.article-tabs__content`);

            if (newTab) {
                newTab.classList.add('active');
            }

            if (newContent) {
                newContent.classList.add('active');

                setTimeout(() => {
                    const offsetElement = newTab;

                    if (offsetElement) {
                        const rect = offsetElement.getBoundingClientRect();
                        const offsetTop = rect.top + window.scrollY;

                        window.scrollTo({
                            top: offsetTop,
                            behavior: 'smooth',
                        });
                    }
                }, 0);
            }
        });
    },

	switchTabFromUrl: function() {
		const hash = window.location.hash;

		if (hash) {
			const tabLink = document.querySelector(`.article-tabs__nav a[href="${hash}"]`);
			const tabContent = document.querySelector(hash);

			if (tabLink && tabContent) {
				document.querySelectorAll('.article-tabs__nav li').forEach(li => li.classList.remove('active'));
				document.querySelectorAll('.article-tabs__content').forEach(content => content.classList.remove('active'));

				tabLink.parentElement.classList.add('active');
				tabContent.classList.add('active');
			}
		}
	}

};

export { poi };